export default __webpack_public_path__ + "media/images/main/arrow-blue2_h-19a11403a0dcdc1bfc2876542d3810a1.png";